import { render, staticRenderFns } from "./PermitHistoryPage.vue?vue&type=template&id=5aec1ca4&"
import script from "./PermitHistoryPage.vue?vue&type=script&lang=js&"
export * from "./PermitHistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports